export const namedColor = (name: string) => `rgb(var(--color-${name}))`;
